import { render, staticRenderFns } from "./LoadingSplash.vue?vue&type=template&id=3199c15c"
import script from "./LoadingSplash.vue?vue&type=script&lang=ts"
export * from "./LoadingSplash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports